import CheckIcon from '@mui/icons-material/Check';
import { Box, List, ListItem, Stack, ThemeProvider, Typography } from '@mui/material';
import React from 'react';
import { generateTheme } from '../themes';
import { RPMButton } from './subComponents/RPMButton';
import { RPMText } from './subComponents/RPMText';



const CallToActionSlice = ({ sliceData }) => {
    // Destructuring the required fields from sliceData

    console.log("cta sliceData is ", sliceData);

    const {
        primary: {
            color_theme,
            headline,
            bodytext,
            selling_points,
            cta_text,
            cta_link,
            cta_subtitle,
            button_style = 'filled'
        },
    } = sliceData;

    const theme = generateTheme(color_theme);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, p: 0, background: theme.palette.background.default }}>
                <Stack spacing={0} sx={{ flex: 1, p: { xs: 4, md: 12 }, mb: { xs: 0, md: 0 }, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <RPMText priscmicField={headline} variant="h2" elementRenderType="h2" />
                    <RPMText priscmicField={bodytext} variant="p" elementRenderType="p" />

                </Stack>
                <Stack spacing={2} sx={{ flex: 1, p: { xs: 4, md: 12 }, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <List>
                        {selling_points.map((feature, fidx) => (
                            <ListItem key={fidx}>
                                <CheckIcon sx={{ color: "text.primary", mr: 1 }} />
                                <Typography variant="h4" component="h3" color="text.primary" sx={{ marginBottom: "0", ml: 1 }}>{feature.text}</Typography>
                            </ListItem>
                        ))}
                    </List>

                    <Stack spacing={1} sx={{ justifyContent: 'flex-start', alignItems: 'center', width: "100%" }}>
                        {cta_link?.url &&
                            <RPMButton link={cta_link} linktext={cta_text} type={
                                button_style === 'outlined' ? 'outlined' :
                                button_style === 'outlined-contrast' ? 'outlined-contrast' :
                                button_style === 'filled-contrast' ? 'contained-contrast' :
                                'contained'
                            } />

                        }
                        {cta_subtitle && <RPMText priscmicField={cta_subtitle} variant="p" elementRenderType="p" sx={{ mt: "0 !important" }} />}
                    </Stack>
                </Stack>
            </Box>
        </ThemeProvider>
    );
};

export default CallToActionSlice;